import Step from './Step';
import WizardComponent from './Wizard';
import { CompoundedComponent } from './interfaces';

const Wizard = WizardComponent as CompoundedComponent;
Wizard.Step = Step;

export * from './interfaces';
export default Wizard;
